export class MerchantKountSettingModel {
  kount_enable?: boolean;
  api?: string;
  mid?: string;
  web_hook?: string;
}
